import { render, staticRenderFns } from "./authSuccess.vue?vue&type=template&id=60ffb422&scoped=true&"
import script from "./authSuccess.vue?vue&type=script&lang=js&"
export * from "./authSuccess.vue?vue&type=script&lang=js&"
import style0 from "./authSuccess.vue?vue&type=style&index=0&id=60ffb422&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ffb422",
  null
  
)

export default component.exports